import i18n from '../../i18n';

const iconTypes = {
    watch: {
        name: 'visibility',
        colorClass: 'watchColor'
    },
    achievement: {
        name: 'star',
        colorClass: 'achievementColor'
    },
    note: {
        name: 'edit',
        colorClass: 'noteColor'
    }
};

const RecordService = {
    getRecordIcon(type) {
        return iconTypes[type].name;
    },
    getRecordAvatarColor(type) {
        const arr = [];
        const color = iconTypes[type].colorClass;
        arr.push(color);
        return arr;
    },

    getRecordText(item) {
        let body;
        switch (item.type) {
            case 'watch':
                body = `<span class="recordLink">${item.session.title}</span>`;
                break;

            case 'achievement':
                body = i18n.t(
                    `notifications.${item.data.achievement.type}.goal_${item.data.achievement.value}`
                );
                break;

            default:
                body = item.note.body;
                break;
        }
        return body;
    },

    getRecordTitle(item) {
        let title;
        switch (item.type) {
            case 'watch':
                title = '';
                break;

            case 'achievement':
                title = i18n.t(
                    `notifications.${item.data.achievement.type}.title`
                );
                break;

            default:
                title = item.note.title;
                break;
        }
        return title;
    }
};

export default RecordService;
